/* ==========================================================================
   MX theme – mx-video-hub.js
   <mx-video-hub>  The Video Hub page.
     - Cards rise into view once.
     - After load, every page of the collection's videos is read (sections/mx-video-feed.liquid), so the type tabs
       show real totals and tabs and search cover all videos (then pages are made here, N videos each).
       Without that, tabs and search work on the videos of the page on screen, and the page links still work.
     - A card opens the video in a popup that grows out of the card; arrows and the keyboard step through the
       videos in view; closing stops the video. The product's price, stock, View product and Add to cart
       (one-variant products) sit beside the player.
   ========================================================================== */
(function () {
  'use strict';
  if (customElements.get('mx-video-hub')) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var EASE = 'cubic-bezier(.2,.85,.25,1)';
  function fill(t, v) { return String(t || '').replace(/\[(\w+)\]/g, function (m, k) { return k in v ? v[k] : m; }); }
  function fmt(n) { return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  class MXVideoHub extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.cleanup = [];
      this.grid = this.querySelector('[data-mxvh-grid]');
      this.pagesNav = this.querySelector('[data-mxvh-pages]');
      this.empty = this.querySelector('[data-mxvh-empty]');
      this.live = this.querySelector('[data-mxvh-live]');
      this.modal = this.querySelector('[data-mxvh-modal]');
      this.panel = this.querySelector('[data-mxvh-panel]');
      this.stage = this.querySelector('[data-mxvh-stage]');
      this.player = this.querySelector('[data-mxvh-player]');
      this.side = this.querySelector('[data-mxvh-side]');
      this.per = Number(this.getAttribute('data-per')) || 20;
      this.kind = 'all';
      this.q = '';
      this.page = 1;
      this.client = false;
      this.all = null;
      if (!this.grid) return;
      this.serverCells = Array.prototype.slice.call(this.grid.children);
      this.emptyText = this.empty ? this.empty.textContent : '';
      this.reveal(this.serverCells);

      this.on(this, 'click', function (e) {
        var tab = e.target.closest('[data-mxvh-tab]');
        if (tab) return self.setKind(tab.getAttribute('data-mxvh-tab'));
        var pg = e.target.closest('[data-mxvh-goto]');
        if (pg) { e.preventDefault(); self.page = Number(pg.getAttribute('data-mxvh-goto')); self.render(true); return; }
        var play = e.target.closest('[data-mxvh-play]');
        if (play && self.contains(play) && !self.modal.contains(play)) { e.preventDefault(); self.open(play); return; }
        if (e.target.closest('[data-mxvh-close]')) { self.close(); return; }
        var step = e.target.closest('[data-mxvh-step]');
        if (step) { self.step(Number(step.getAttribute('data-mxvh-step'))); return; }
        var add = e.target.closest('[data-mxvh-add]');
        if (add) self.addToCart(add);
      });
      var input = this.querySelector('[data-mxvh-q]');
      var form = this.querySelector('[data-mxvh-search-form]');
      if (form) this.on(form, 'submit', function (e) { e.preventDefault(); if (input) { self.q = input.value.trim().toLowerCase(); self.page = 1; self.render(true); } });
      if (input) this.on(input, 'input', function () { clearTimeout(self.qT); self.qT = setTimeout(function () { self.q = input.value.trim().toLowerCase(); self.page = 1; self.render(false); }, 220); });
      if (this.modal) {
        this.on(this.modal, 'cancel', function (e) { e.preventDefault(); self.close(); });
        this.on(this.modal, 'click', function (e) { if (e.target === self.modal) self.close(); });
        this.on(document, 'keydown', function (e) {
          if (!self.modal.open) return;
          if (e.key === 'ArrowRight') self.step(1);
          else if (e.key === 'ArrowLeft') self.step(-1);
        });
      }
      this.loadFeed();
    }
    disconnectedCallback() {
      (this.cleanup || []).forEach(function (fn) { fn(); });
      if (this.io) this.io.disconnect();
    }
    on(t, type, fn) { t.addEventListener(type, fn); this.cleanup.push(function () { t.removeEventListener(type, fn); }); }

    /* ---------- entrance ---------- */
    reveal(cells) {
      var self = this;
      if (!this.classList.contains('mxvh--anim') || reduce.matches || !('IntersectionObserver' in window)) { cells.forEach(function (c) { c.classList.add('is-in'); }); return; }
      if (!this.io) this.io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); self.io.unobserve(x.target); } }); }, { rootMargin: '0px 0px -6% 0px' });
      cells.forEach(function (c) { self.io.observe(c); });
      setTimeout(function () { cells.forEach(function (c) { c.classList.add('is-in'); }); }, 3500);
    }

    /* ---------- every video of the collection ---------- */
    loadFeed() {
      var self = this;
      var base = this.getAttribute('data-feed');
      if (!base || !window.fetch || !window.DOMParser) return;
      var parse = function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var box = doc.querySelector('[data-mxvh-feed]');
        return { pages: box ? Number(box.getAttribute('data-pages')) || 1 : 1, cells: box ? Array.prototype.slice.call(box.querySelectorAll('.mxvh__cell')) : [] };
      };
      var get = function (n) { return fetch(base + '&page=' + n, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(parse); };
      get(1).then(function (first) {
        var pages = Math.min(first.pages, 60);
        var results = [first.cells];
        var queue = [];
        for (var p = 2; p <= pages; p++) queue.push(p);
        var run = function () {
          if (!queue.length) return Promise.resolve();
          var n = queue.shift();
          return get(n).then(function (r) { results[n - 1] = r.cells; return run(); });
        };
        return Promise.all([run(), run(), run()]).then(function () {
          var all = [];
          results.forEach(function (list) { (list || []).forEach(function (c) { all.push(document.importNode(c, true)); }); });
          self.all = all;
          self.counts();
          if (self.client) self.render(false);
        });
      }).catch(function () { /* tabs and search stay on the page on screen */ });
    }
    counts() {
      var n = { all: 0, review: 0, demo: 0, short: 0 };
      (this.all || []).forEach(function (c) { n.all++; var k = c.getAttribute('data-kind'); if (k in n) n[k]++; });
      this.querySelectorAll('[data-mxvh-n]').forEach(function (el) { el.textContent = fmt(n[el.getAttribute('data-mxvh-n')] || 0); el.hidden = false; });
    }

    /* ---------- tabs, search, pages ---------- */
    setKind(kind) {
      this.kind = kind;
      this.querySelectorAll('[data-mxvh-tab]').forEach(function (t) { var on = t.getAttribute('data-mxvh-tab') === kind; t.classList.toggle('is-active', on); t.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      this.page = 1;
      this.render(false);
    }
    list() {
      var self = this;
      var pool = this.all || this.serverCells;
      return pool.filter(function (c) {
        return (self.kind === 'all' || c.getAttribute('data-kind') === self.kind) && (!self.q || (c.getAttribute('data-q') || '').indexOf(self.q) > -1);
      });
    }
    render(scroll) {
      var self = this;
      this.client = true;
      var list = this.list();
      var pages = Math.max(1, Math.ceil(list.length / this.per));
      if (this.page > pages) this.page = pages;
      var slice = list.slice((this.page - 1) * this.per, this.page * this.per);
      var frag = document.createDocumentFragment();
      slice.forEach(function (c, i) { var n = c.cloneNode(true); n.classList.remove('is-in'); n.style.setProperty('--i', i % 10); frag.appendChild(n); });
      this.grid.replaceChildren(frag);
      this.reveal(Array.prototype.slice.call(this.grid.children));
      if (this.empty) {
        this.empty.hidden = list.length > 0;
        if (!list.length) this.empty.textContent = this.q ? fill(this.getAttribute('data-l-none') || '', { q: this.q }) : this.emptyText;
      }
      this.buildPages(pages);
      if (this.live) this.live.textContent = String(list.length);
      if (scroll) {
        var top = this.querySelector('.mxvh__tabs').getBoundingClientRect().top + window.scrollY - 120;
        if (window.scrollY > top) window.scrollTo({ top: top, behavior: reduce.matches ? 'auto' : 'smooth' });
      }
    }
    buildPages(pages) {
      var nav = this.pagesNav;
      if (!nav) return;
      nav.hidden = pages < 2;
      if (pages < 2) { nav.innerHTML = ''; return; }
      var cur = this.page;
      var lp = this.getAttribute('data-l-page') || 'Page';
      var arrow = function (d) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + (d < 0 ? 'M15 6l-6 6 6 6' : 'M9 6l6 6-6 6') + '"/></svg>'; };
      var html = '<button type="button" class="mxvh__pg mxvh__pg--nav' + (cur === 1 ? ' is-off' : '') + '" data-mxvh-goto="' + (cur - 1) + '" aria-label="' + esc(this.getAttribute('data-l-prev')) + '"' + (cur === 1 ? ' disabled' : '') + '>' + arrow(-1) + '</button>';
      var shown = [];
      for (var p = 1; p <= pages; p++) if (p === 1 || p === pages || Math.abs(p - cur) <= 1) shown.push(p);
      var last = 0;
      shown.forEach(function (p) {
        if (p - last > 1) html += '<span class="mxvh__pg is-gap" aria-hidden="true">…</span>';
        html += p === cur ? '<span class="mxvh__pg is-current" aria-current="page">' + p + '</span>' : '<button type="button" class="mxvh__pg" data-mxvh-goto="' + p + '" aria-label="' + esc(lp) + ' ' + p + '">' + p + '</button>';
        last = p;
      });
      html += '<button type="button" class="mxvh__pg mxvh__pg--nav' + (cur === pages ? ' is-off' : '') + '" data-mxvh-goto="' + (cur + 1) + '" aria-label="' + esc(this.getAttribute('data-l-next')) + '"' + (cur === pages ? ' disabled' : '') + '>' + arrow(1) + '</button>';
      nav.innerHTML = html;
    }

    /* ---------- the popup ---------- */
    buttons() { return Array.prototype.slice.call(this.grid.querySelectorAll('[data-mxvh-play]')); }
    fill(btn) {
      var d = btn.dataset;
      var kind = d.kind;
      var tall = kind === 'short' || (d.ratio && Number(d.ratio) < 1);
      this.modal.classList.toggle('is-short', !!tall);
      var media;
      if (d.provider === 'youtube') media = '<iframe src="https://www.youtube-nocookie.com/embed/' + encodeURIComponent(d.id) + '?autoplay=1&rel=0&playsinline=1&modestbranding=1" title="' + esc(d.title) + '" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowfullscreen></iframe>';
      else if (d.provider === 'vimeo') media = '<iframe src="https://player.vimeo.com/video/' + encodeURIComponent(d.id) + '?autoplay=1" title="' + esc(d.title) + '" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
      else media = '<video src="' + esc(d.src) + '" controls autoplay playsinline></video>';
      this.player.innerHTML = media;
      var tab = this.querySelector('[data-mxvh-tab="' + kind + '"]');
      var kindLabel = tab ? tab.querySelector('span:not(.mxvh__tab-icon):not(.mxvh__tab-n)').textContent : '';
      var icon = tab ? tab.querySelector('.mxvh__tab-icon').innerHTML : '';
      var stockCls = d.available === 'false' ? ' is-out' : '';
      var html = '';
      var k = 0;
      if (kindLabel) html += '<span class="mxvh-modal__kind" style="--d:' + k++ + '">' + icon + esc(kindLabel) + '</span>';
      if (d.image) html += '<img class="mxvh-modal__pimg" style="--d:' + k++ + '" src="' + esc(d.image.replace(/width=\d+/, 'width=600')) + '" alt="" loading="lazy">';
      html += '<div style="--d:' + k++ + '">' + (d.vendor ? '<p class="mxvh-modal__vendor">' + esc(d.vendor) + '</p>' : '') + '<h2 class="mxvh-modal__title">' + esc(d.title) + '</h2></div>';
      html += '<p class="mxvh-modal__price mx-num" style="--d:' + k++ + '">' + esc(d.price) + '<span class="mxvh-card__stock' + stockCls + '">' + esc(d.stock) + '</span></p>';
      html += '<div class="mxvh-modal__btns" style="--d:' + k++ + '">';
      if (d.variant && d.available !== 'false') html += '<button type="button" class="mxvh-modal__btn mxvh-modal__btn--primary" data-mxvh-add="' + esc(d.variant) + '">' + esc(this.getAttribute('data-l-add')) + '</button>';
      html += '<a class="mxvh-modal__btn" href="' + esc(d.url) + '">' + esc(this.getAttribute('data-l-view')) + '</a></div>';
      this.side.innerHTML = html;
      var list = this.buttons();
      var i = list.indexOf(btn);
      this.panel.querySelectorAll('[data-mxvh-step]').forEach(function (b) { b.hidden = list.length < 2; });
      this.index = i;
    }
    open(btn) {
      var self = this;
      if (!this.modal || typeof this.modal.showModal !== 'function') { window.open(btn.dataset.url, '_self'); return; }
      this.origin = btn;
      this.fill(btn);
      document.documentElement.style.overflow = 'hidden';
      this.modal.showModal();
      requestAnimationFrame(function () { self.modal.classList.add('is-open'); });
      if (!reduce.matches && this.panel.animate) {
        var from = this.fromCard(btn);
        this.panel.animate([{ transform: from, opacity: 0.35, borderRadius: '18px' }, { transform: 'none', opacity: 1, borderRadius: '22px' }], { duration: 560, easing: EASE });
      }
      var close = this.panel.querySelector('[data-mxvh-close]');
      if (close) close.focus({ preventScroll: true });
    }
    fromCard(btn) {
      var r = btn.getBoundingClientRect();
      var p = this.panel.getBoundingClientRect();
      if (!p.width || !r.width) return 'scale(.9)';
      var dx = (r.left + r.width / 2) - (p.left + p.width / 2);
      var dy = (r.top + r.height / 2) - (p.top + p.height / 2);
      var s = Math.max(0.12, Math.min(r.width / p.width, r.height / p.height));
      return 'translate(' + dx.toFixed(1) + 'px,' + dy.toFixed(1) + 'px) scale(' + s.toFixed(3) + ')';
    }
    close() {
      var self = this;
      if (!this.modal || !this.modal.open || this.closing) return;
      this.closing = true;
      this.modal.classList.remove('is-open');
      var done = function () {
        self.modal.close();
        self.player.innerHTML = '';
        self.side.innerHTML = '';
        document.documentElement.style.overflow = '';
        self.closing = false;
        var back = self.origin && self.origin.isConnected ? self.origin : null;
        if (back) back.focus({ preventScroll: true });
      };
      var target = this.origin && this.origin.isConnected && this.origin.getBoundingClientRect().width ? this.fromCard(this.origin) : 'scale(.92)';
      if (!reduce.matches && this.panel.animate) {
        var a = this.panel.animate([{ transform: 'none', opacity: 1 }, { transform: target, opacity: 0 }], { duration: 380, easing: 'cubic-bezier(.4,0,.6,1)' });
        a.onfinish = done;
      } else done();
    }
    step(d) {
      var self = this;
      var list = this.buttons();
      if (list.length < 2 || !this.modal.open) return;
      var i = (this.index + d + list.length) % list.length;
      var btn = list[i];
      this.origin = btn;
      if (reduce.matches) { this.fill(btn); return; }
      this.stage.classList.add('is-swapping');
      setTimeout(function () { self.fill(btn); self.stage.classList.remove('is-swapping'); }, 220);
    }
    addToCart(btn) {
      var id = Number(btn.getAttribute('data-mxvh-add'));
      var label = btn.textContent;
      var self = this;
      btn.disabled = true;
      var api = window.MXTheme && window.MXTheme.cart;
      var req = api ? api.add({ items: [{ id: id, quantity: 1 }] }, { open: false, toast: false })
        : fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) }).then(function (r) { if (!r.ok) throw new Error(r.status); });
      Promise.resolve(req).then(function () {
        btn.textContent = self.getAttribute('data-l-added') || 'Added';
        document.dispatchEvent(new CustomEvent('mx:cart:refresh', { detail: { source: 'mx-video-hub' } }));
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2400);
      }).catch(function () { btn.textContent = label; btn.disabled = false; });
    }
  }
  customElements.define('mx-video-hub', MXVideoHub);
})();
